'use client';

import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
// import Link from 'next/link';

const ServicesComponent = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

const services = useMemo(
  () => [
    {
      id: "civil-works",
      title: "Civil Works",
      slug: "civil-works",
      description:
        "Complete civil construction services including excavation, PCC & RCC works, foundations, columns, slabs, reinforcement steel fixing, blockwork, plastering, flooring base, waterproofing, drainage, paving, boundary walls, repair, maintenance, and minor demolition works.",
      color: "#3b82f6",
      image:
        "https://5.imimg.com/data5/SELLER/Default/2022/4/JX/OM/FU/2952612/civil-construction-500x500.jpg?w=600&h=400&fit=crop&q=80",
      badge: "Available",
    },

    {
      id: "mep-works",
      title: "MEP Works",
      slug: "mep-works",
      description:
        "End-to-end MEP subcontracting services. Mechanical HVAC and ducting systems, electrical power distribution, lighting and low-voltage networks, plumbing, drainage, and fire-fighting systems delivered by skilled engineers, supervisors, and technicians.",
      color: "#3b82f6",
      image:
        "https://budlong.com/wp-content/uploads/2024/10/mep-design.jpg?w=600&h=400&fit=crop&q=80",
      badge: "Available",
    },

    {
      id: "finishing-painting",
      title: "Finishing & Painting Works",
      slug: "finishing-painting",
      description:
        "Professional finishing and painting services including plastering, sanding, priming, interior and exterior painting, decorative textures, protective coatings, and detailed finishing works supported by skilled painters and supervisors.",
      color: "#3b82f6",
      image:
        "https://el-behairy.com/wp-content/uploads/2021/06/05.jpg?e=2147483647&v=beta&t=3-j2fBmf0oMof_1Swm5BN0t07JsUuwIg-sH6RRbJ1Fg?w=600&h=400&fit=crop&q=80",
      badge: "Available",
    },

    {
      id: "sub-contract-works",
      title: "Sub-Contract Works",
      slug: "sub-contract-works",
      description:
        "Comprehensive subcontracting solutions across civil, MEP, and specialized trades including flooring, painting, carpentry, and renovation works. Reliable execution with trained manpower and project support teams.",
      color: "#3b82f6",
      image:
        "https://www.hcr-llc.com/hs-fs/hubfs/Blog_Images/Subcontracting.jpg?width=750&name=Subcontracting.jpg?w=600&h=400&fit=crop&q=80",
      badge: "Available",
    },

    {
      id: "supporting-staff",
      title: "Supporting Staff",
      slug: "supporting-staff",
      description:
        "Reliable supporting manpower including site supervisors, drivers, helpers, laborers, and administrative staff. Flexible deployment, safety-focused workforce, punctual service, and cost-effective manpower solutions.",
      color: "#3b82f6",
      image:
        "https://www.4cornerresources.com/wp-content/uploads/2023/01/Manager-supporting-employees-scaled.jpeg?w=600&h=400&fit=crop&q=80",
      badge: "Available",
    },
  ],
  []
);

//   const services = useMemo(
//     () => [
//       {
//         id: 'electricians',
//         title: 'Electricians',
//         slug: 'electricians',
//         description: 'Skilled electrician supply & full electrical subcontracting. MEP electrical systems, installation & maintenance.',
//         color: '#f59e0b',
//         image: 'https://images.unsplash.com/photo-1581092162562-40038f28c96c?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'hvac',
//         title: 'HVAC Ductman',
//         slug: 'hvac-ductman',
//         description: 'Skilled HVAC ductman supply & complete MEP ductwork subcontracting. System design & installation.',
//         color: '#3b82f6',
//         image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'masons',
//         title: 'Masons & Concrete',
//         slug: 'masons-concrete',
//         description: 'Skilled mason supply & complete masonry subcontracting. Foundation work, brickwork & repair.',
//         color: '#8b5cf6',
//         image: 'https://images.unsplash.com/photo-1581092162562-40038f28c96c?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'plumbers',
//         title: 'Plumbers',
//         slug: 'plumbers',
//         description: 'Plumber supply & complete plumbing subcontracting. Water supply systems, drainage & MEP.',
//         color: '#06b6d4',
//         image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'helpers',
//         title: 'Construction Helpers',
//         slug: 'construction-helpers',
//         description: 'Construction helper supply & subcontracting. Material handling, site prep & cleanup services.',
//         color: '#10b981',
//         image: 'https://images.unsplash.com/photo-1581092162562-40038f28c96c?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'welders',
//         title: 'Welders',
//         slug: 'welders',
//         description: 'Skilled welder supply & complete structural welding subcontracts. Structural & pipe welding.',
//         color: '#ef4444',
//         image: 'https://images.unsplash.com/photo-1581092162562-40038f28c96c?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'painters',
//         title: 'Painting Contractors',
//         slug: 'painting-contractors',
//         description: 'Professional painting subcontracting. Residential, commercial & industrial painting.',
//         color: '#f97316',
//         image: 'https://images.unsplash.com/photo-1581092162562-40038f28c96c?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//       {
//         id: 'transport',
//         title: 'Staff Transportation',
//         slug: 'staff-transportation',
//         description: '15-seater worker bus. Reliable transportation for construction crews across Qatar.',
//         color: '#84cc16',
//         image: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=600&h=400&fit=crop&q=80',
//         badge: 'Available',
//       },
//     ],
//     []
//   );

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.08, delayChildren: 0.2 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
  };

  return (
    <>
      <section
        style={{
          padding: '100px 20px',
          background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
        aria-labelledby="services-title"
      >
        {/* Background decoration */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '300px',
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, transparent 100%)',
            pointerEvents: 'none',
          }}
        />

        {/* Header Section */}
        <motion.div
          ref={ref}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={titleVariants}
          style={{
            maxWidth: '1200px',
            margin: '0 auto 80px',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              background: 'rgba(59, 130, 246, 0.1)',
              borderRadius: '20px',
              marginBottom: '20px',
              border: '1px solid rgba(59, 130, 246, 0.2)',
            }}
          >
            <span style={{ fontSize: '12px', fontWeight: 600, color: '#3b82f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Our Expertise
            </span>
          </div>

          <h1
            id="services-title"
            style={{
              fontSize: 'clamp(32px, 6vw, 48px)',
              fontWeight: 900,
              color: '#111827',
              marginBottom: '16px',
              letterSpacing: '-1px',
              lineHeight: 1.2,
            }}
          >
            Professional Services
            <br />
            <span style={{ background: 'linear-gradient(135deg, #3b82f6, #06b6d4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Across All Trades
            </span>
          </h1>

          <p
            style={{
              fontSize: 'clamp(14px, 2.5vw, 18px)',
              color: '#6b7684',
              marginBottom: '30px',
              maxWidth: '700px',
              margin: '0 auto 30px',
              lineHeight: '1.8',
              fontWeight: 500,
            }}
          >
            Comprehensive skilled workforce solutions with certified professionals and immediate mobilization across Qatar
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
            <div style={{ width: '40px', height: '3px', background: '#3b82f6', borderRadius: '2px' }} />
            <div style={{ width: '10px', height: '3px', background: '#06b6d4', borderRadius: '2px' }} />
            <div style={{ width: '10px', height: '3px', background: '#8b5cf6', borderRadius: '2px' }} />
          </div>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px',
            maxWidth: '1200px',
            margin: '0 auto',
            position: 'relative',
            zIndex: 1,
          }}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} variants={cardVariants} />
          ))}
        </motion.div>
      </section>

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: 'Professional Construction Services',
            description: 'Comprehensive skilled workforce solutions across all construction trades in Qatar',
            serviceArea: 'QA',
            areaServed: 'Qatar',
            hasOfferCatalog: {
              '@type': 'OfferCatalog',
              name: 'Construction Services',
              itemListElement: services.map((service) => ({
                '@type': 'Offer',
                name: service.title,
                description: service.description,
                url: `/services/${service.slug}`,
              })),
            },
          }),
        }}
      />
    </>
  );
};

const ServiceCard = ({ service, variants }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  const imageFallback = `linear-gradient(135deg, ${service.color}40 0%, ${service.color}20 100%)`;

  return (
    <motion.article
      variants={variants}
      whileHover={{ y: -12, transition: { duration: 0.3 } }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: '#ffffff',
        border: `1px solid ${isHovered ? service.color + '30' : '#e5e7eb'}`,
        borderRadius: '16px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        boxShadow: isHovered
          ? `0 25px 50px ${service.color}20, 0 8px 16px rgba(0,0,0,0.08)`
          : '0 4px 12px rgba(0, 0, 0, 0.04)',
        transform: isHovered ? 'translateY(-12px)' : 'translateY(0)',
      }}
    >
      {/* Image Container */}
      <div
        style={{
          position: 'relative',
          height: '220px',
          overflow: 'hidden',
          background: imageError ? imageFallback : `linear-gradient(135deg, ${service.color}20 0%, ${service.color}05 100%)`,
        }}
      >
        {!imageError && (
          <img
            src={service.image}
            alt={`${service.title} - Professional construction services in Qatar`}
            title={service.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.5s ease',
              transform: isHovered ? 'scale(1.08)' : 'scale(1)',
            }}
            onError={() => setImageError(true)}
            loading="lazy"
          />
        )}

        {/* Overlay gradient */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(135deg, ${service.color}40 0%, transparent 100%)`,
            opacity: isHovered ? 0.6 : 0.3,
            transition: 'opacity 0.4s ease',
          }}
        />

        {/* Badge */}
        <div
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            padding: '6px 14px',
            background: service.color,
            color: 'white',
            fontSize: '11px',
            fontWeight: 700,
            borderRadius: '20px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            boxShadow: `0 4px 12px ${service.color}40`,
          }}
        >
          {service.badge}
        </div>

        {/* Color accent line */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: isHovered ? '5px' : '3px',
            background: service.color,
            transition: 'height 0.3s ease',
          }}
        />
      </div>

      {/* Content */}
      <div style={{ padding: '32px 24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <h2
          style={{
            fontSize: '20px',
            fontWeight: 800,
            color: '#111827',
            marginBottom: '12px',
            margin: '0 0 12px 0',
            letterSpacing: '-0.3px',
          }}
        >
          {service.title}
        </h2>

        <p
          style={{
            fontSize: '14px',
            color: '#6b7684',
            lineHeight: '1.7',
            margin: 0,
            flex: 1,
            marginBottom: '16px',
          }}
        >
          {service.description}
        </p>

        {/* CTA Button */}
        {/* <Link href={`/services/${service.slug}`} style={{ textDecoration: 'none', width: '100%' }}> */}
          <motion.a
  href="/services"
  whileHover={{ scale: 1.02 }}
  whileTap={{ scale: 0.98 }}
  style={{
    display: 'block',      // Required for <a> to respect width: 100%
    textAlign: 'center',   // Center the text
    textDecoration: 'none', // Remove underline
    padding: '12px 20px',
    background: service.color,
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: 700,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    boxShadow: `0 4px 12px ${service.color}30`,
    width: '100%',
  }}
>
  Learn More
</motion.a>
        {/* </Link> */}
      </div>

      {/* Schema.org Structured Data for Service */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: service.title,
            description: service.description,
            provider: {
              '@type': 'LocalBusiness',
              name: 'Professional Construction Services',
              areaServed: 'QA',
            },
            url: `/services/${service.slug}`,
          }),
        }}
      />
    </motion.article>
  );
};

export default ServicesComponent;
